module.exports = __webpack_public_path__ + "media/icons/wlasciciel-firma-white-7c1e6feb.png";